import http from '../lib/http';

export const CHECK_DOMAIN_START = 'CHECK_DOMAIN_START';
export const CHECK_DOMAIN_ERROR = 'CHECK_DOMAIN_ERROR';
export const CHECK_DOMAIN_SUCCESS = 'CHECK_DOMAIN_SUCCESS';

export function checkDomain(domain) {
    return {
        type: 'CHECK_DOMAIN',
        payload: {
            promise: getCheckDomain(domain)
        }
    };
}

async function getCheckDomain(domain) {
    const res = await http.get(`/app/check-domain/${domain}`, {headers: {'DownloadDomain': domain}});
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/chooseDomain/actions.js